var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('button',{ref:"btnGoTop",staticClass:"btnGoTop",style:({'display': _vm.displayBtnGoTop}),on:{"click":_vm.clickGoTop}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon",staticStyle:{"font-size":"35px"}},[_c('i',{staticClass:"mdi mdi-chevron-up"})])
}]

export { render, staticRenderFns }